import React, { useEffect, useState } from 'react'
import { useMainContext } from '../../core/contexts/main'

const languages = {
    en: 'english',
    fa: 'فارسی',
}

const languageOptions = ['english', 'فارسی']

const RLangSwitcher = ({ closeModal }) => {
    const {
        main: { lang, setLang },
    } = useMainContext()


    const onSelect = (option) => {
        if (option === 'english') setLang('en')
        if (option === 'فارسی') setLang('fa')
        closeModal()
    }


    return (
        <>
            <div className="flex flex-col">
                {languageOptions.map((option, idx) => {
                    const isActive = languages[lang] === option

                    return (
                        <>
                            <button
                                key={option}
                                onClick={(e) => {
                                    e.stopPropagation();
                                    onSelect(option)
                                }}
                                className={`py-3 text-center  capitalize ${isActive ? 'font-bold opacity-100' : 'opacity-70'
                                    }`}
                            >
                                {option}
                            </button>
                            {
                                idx !== languageOptions.length - 1 && <div className="h-[1px] w-[99%] bg-gradient-to-r from-primaryOrange/0 via-primaryOrange to-primaryOrange/0" />

                            }
                        </>
                    )
                })}
            </div>
        </>
    )
}

export default RLangSwitcher
